import { html, ref, repeat } from '@microsoft/fast-element';
import type { AuditGrid } from './audit-grid';
import { sync } from '@genesislcap/foundation-utils';

export const AuditGridTemplate = html<AuditGrid>`
  <div class="header-wrapper">
    <div class="input-wrapper">
      <zero-select
        class="input-control"
        :value=${sync((x) => x.typeDropdownValue)}
        ${ref('typeDropdown')}
      >
        <zero-option value="">Select Type</zero-option>

        ${repeat(
          (x) => x.typeDropdownValues,
          html`
            <zero-option value="${(x) => x.value}">${(x) => x.text}</zero-option>
          `
        )}
      </zero-select>
      <zero-text-field
        type="text"
        placeholder="Enter ID..."
        :value="${sync((x) => x.searchTextValue)}"
      ></zero-text-field>
      <zero-button
        @click=${(x) => x.searchAudit()}
        ?disabled="${(x) => !(x.searchTextValue && x.typeDropdownValue)}"
      >
        Search Audit
      </zero-button>
    </div>
    <zero-button
      :disabled=${(x) => x.auditList.length}
      appearance="primary"
      @click=${(x) => x.downloadGrid()}
    >
      Export to CSV
    </zero-button>
  </div>

  <zero-grid-pro
    class="grid-styles"
    only-template-col-defs
    sideBar=""
    ${ref('auditGrid')}
    @onGridReady="${(x) => x.onGridReady()}"
  ></zero-grid-pro>
`;
